import { createFileRoute } from "@tanstack/react-router";
import GrantsRoute from "@/pages/GrantsRoute";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/recursos/subvenciones")({
  head: () => pageHead("grants", "es", { links: false }),
  component: GrantsRoute,
});
